'use client';

import useDriftStore from '../stores/DriftStore/useDriftStore';
import useMarkPrice from './useMarkPrice';
import { useMarketPriceState } from './query/orderbook/useMarketPriceState';

const useCurrentMarketMarkPrice = () => {
	const currentMarketId = useDriftStore((s) => s.selectedMarket.marketId);

	const pricingFeedMarkPrice = useMarkPrice(currentMarketId);

	const { data: marketPriceState } = useMarketPriceState(
		currentMarketId ?? null
	);

	// Prefer orderbook mark price for the currently selected market
	// so it stays in sync with the orderbook divider display
	if (marketPriceState?.markPrice && !marketPriceState.markPrice.eqZero()) {
		return marketPriceState.markPrice;
	}

	return pricingFeedMarkPrice;
};

export default useCurrentMarketMarkPrice;
